import { useRoutes } from 'react-router-dom';
import { PartialRouteObject } from 'react-router';
import React, { lazy } from 'react';
import LoginPage from '../views/login';
import LayoutPage from '../views/layout'
const Dashboard = lazy(() => import('../views/dashboard'))
const Minibasic = lazy(() => import('../views/minibasic'))
const Account = lazy(() => import('../views/account'))
const Role = lazy(() => import('../views/role'))
const Homeconfig = lazy(() => import('../views/homeconfig'))
const Banner = lazy(() => import('../views/banner'))
const AddEditBanner = lazy(() => import('../views/banner/addEditBanner'))
const Article = lazy(() => import('../views/article'))
const SaveArticle = lazy(() => import('../views/article/addEditArticle'))
const routerList: PartialRouteObject[] = [
  {
    path: '',
    element: <LayoutPage />,
    children: [
      {
        path: '/',
        element: <Minibasic />
      },
      {
        path: '/minibasic',
        element: <Minibasic />
      },
      {
        path: '/account',
        element: <Account />
      },
      {
        path: '/role',
        element: <Role />
      },
      {
        path: '/homeconfig',
        element: <Homeconfig />
      },
      {
        path: '/banner',
        element: <Banner />
      },
      {
        path: '/addEditBanner',
        element: <AddEditBanner />
      },
      {
        path: '/article',
        element: <Article />
      },
      {
        path: '/saveArticle',
        element: <SaveArticle />
      }
    ]
  },
  {
    path: '/login',
    element: <LoginPage />
  }
]

export default () => useRoutes(routerList)
